import {LabelValue} from './constants/general-constants';

export const CONTENT_TYPES: LabelValue[] = [
  {value: 'Belgesel', label: 'Belgesel'},
  {value: 'CUTV', label: 'CUTV'},
  {value: 'Çocuk', label: 'Çocuk'},
  {value: 'Dizi', label: 'Dizi'},
  {value: 'Eğlence', label: 'Eğlence'},
  {value: 'Film', label: 'Film'},
  {value: 'Müzik', label: 'Müzik'},
  {value: 'Spor', label: 'Spor'},
  {value: 'Tv', label: 'Tv'},
  {value: 'Yaşam', label: 'Yaşam'},
];

export const CONTENT_DEFINITIONS: LabelValue[] = [
  {label: '6k', value: 'SixK'},
  {label: '4K', value: 'FourK'},
  {label: 'HD', value: 'HD'},
  {label: 'SD', value: 'SD'},
  {label: 'HD/SD', value: 'HDSD'},
];
export const VIDEO_FORMATS: LabelValue[] = [
  {label: '6k', value: 'SixK'},
  {label: '4K', value: 'FourK'},
  {label: 'HD', value: 'HD'},
  {label: 'SD', value: 'SD'},
  {label: 'HD/SD', value: 'HDSD'},
  {label: 'TRAILER', value: 'TRAILER'},
  {label: 'COMING SOON', value: 'COMINGSOON'},
  {label: 'SPECIAL CONTENT', value: 'SPECIALCONTENT'},
];
export const TRANSCODEFORMAT: string[] = ['SixK', 'FourK', 'HD', 'SD', 'HDSD', 'TRAILER', 'COMINGSOON', 'SPECIALCONTENT', 'CATCHUP'];
export const TYPES: string[] = ['MOVIE', 'EPISODE', 'SEASON', 'SERIES'];

export const ADVISORIES: any[] = ['VH', 'SC', 'IB'];
export const VIDEO_CODEC: any[] = ['libx264', 'libx265'];

export const ENCODING_PROFILES: any[] = ['main', 'base', 'high444', 'high', 'main10'];
export const PROFILE_TYPES: string[] = ['Encode', 'Transcode'];
export const ENCODING_RESOLUTION: any[] = ['2160p', '1080p', '720p', '540p', '480p', '360p', '240p', '144p'];
export const PLATFORM_ARRAY: string[] = ['Web', 'SmartTV', 'Mobile', 'IPTV'];
export const FRAMERATE: string[] = ['24/25p', '25p', '25/29.97p', '25/30p', '29.97p', '50/60p'];

export const ACODEC: any[] = ['AAC', 'AC3'];
export const PACKAGING: any[] = ['TS', 'HLS', 'HSS', 'DASH'];
export const DEVICES: any[] = ['Smartphone', 'Personal computer', 'Tablet'];
export const OP_SYS: any[] = ['Android', 'Windows', 'IOS', 'OS X'];
export const ENCRIPTION: any[] = ['Widevine', 'PlayReady', 'FairPlay', 'CommonEncryption', 'None'];
export const METHOD: any[] = ['DASH-CENC', 'AES-SAMPLE', 'AES-CTR'];
export const REGION: any[] = ['ALL', 'Türkiye', 'KKTC', 'ABD', 'Almanya', 'Fransa', 'Belçika', 'Hollanda', 'Türki Cumhuriyetler'];

export const PRESENTATION_TYPES_ARR: string[] = [
  'PREROLL',
  'MIDROLL',
  'POSTROLL',
  'INTERSTIAL',
  'PAUSEBANNER',
  'INFOBARBANNER',
  'CATEGORYBANNER',
  'MAINBOARDITEMBANNER',
];

export const VideoOperationProcessName: LabelValue[] = [
  {label: 'Missing Material', value: 'MissingMaterial'},
  {label: 'Encode', value: 'Encode'},
  {label: 'Quality Check First', value: 'Qc1'},
  {label: 'Subtitle Script Check', value: 'SubtitleScriptCheck'},
  {label: 'Third Party', value: 'ThirdParty'},
  {label: 'Censorship Preview', value: 'CensorshipPreview'},
  {label: 'Video Editing', value: 'VideoEditing'},
  {label: 'Quality Check Second', value: 'Qc2'},
  {label: 'Compressing', value: 'Transcoding1st'},
  {label: 'Quality Check Third', value: 'Qc3'},
  {label: 'Transfer', value: 'Transfer'},
  {label: 'Profiling', value: 'Transcoding2nd'},
  {label: 'Package', value: 'Package'},
  {label: 'Completed', value: 'Completed'},
];
export const RedirectProcesses: LabelValue[] = [
  {label: 'Missing Material', value: 'MissingMaterial'},
  {label: 'Encode', value: 'Encode'},
  {label: 'Quality Check First', value: 'Qc1'},
  {label: 'Subtitle Script Check', value: 'SubtitleScriptCheck'},
  {label: 'Third Party', value: 'ThirdParty'},
  {label: 'Censorship Preview', value: 'CensorshipPreview'},
  {label: 'Video Editing', value: 'VideoEditing'},
  {label: 'Quality Check Second', value: 'Qc2'},
  {label: 'Compressing', value: 'Transcoding1st'},
  {label: 'Quality Check Third', value: 'Qc3'},
  {label: 'Package', value: 'Package'},
];
// ['Text', 'VoiceOver', 'Poster', 'Offline', 'Online', 'FinalCheck', 'Planning', 'Transfer', 'Transcoding2nd', 'Completed'],
export const TrailerTasks: LabelValue[] = [
  {label: 'Text', value: 'Text'},
  {label: 'Voice Over', value: 'VoiceOver'},
  {label: 'Poster', value: 'Poster'},
  // {label: 'Offline', value: 'Offline'},
  {label: 'Online', value: 'Online'},
  {label: 'FinalCheck', value: 'FinalCheck'},
  {label: 'Planning', value: 'Planning'},
];

export const ActivityLogScope: LabelValue[] = [
  {label: 'Fundamental', value: 'Fundamental'},
  {label: 'Status', value: 'Status'},
  {label: 'Deal', value: 'Deal'},
  {label: 'Plan', value: 'Plan'},
  {label: 'Metadata', value: 'Metadata'},
  {label: 'Poster', value: 'Poster'},
  {label: 'Video Operation', value: 'VideoOperation'},
  {label: 'Trailer Operation', value: 'TrailerOperation'},
  {label: 'Validation', value: 'Validation'},
];

export const ProgramActivityLogScope: LabelValue[] = [
  {label: 'Metadata', value: 'Metadata'},
  {label: 'Poster', value: 'Poster'},
  {label: 'Insert Epg', value: 'Epg'},
  {label: 'Change Epg', value: 'Epg'},
  {label: 'Delete Epg', value: 'Epg'},
];

export const validationChangeType: LabelValue[] = [
  {label: 'Published', value: 'Published'},
  {label: 'Metadata Update', value: 'MetadataUpdate'},
  {label: 'Video Material Update', value: 'VideoMaterialUpdate'},
  {label: 'Poster Update', value: 'PosterUpdate'},
  {label: 'Plan Update', value: 'PlanUpdate'},
  {label: 'Label Update', value: 'LabelUpdate'},
  {label: 'Trailer Add', value: 'TrailerAdd'},
  {label: 'Trailer Remove', value: 'TrailerRemove'},
  {label: 'Label Update', value: 'SubtitleUpdate'},
];

export const ItemCounts: LabelValue[] = [
  {label: '10', value: 10},
  {label: '15', value: 15},
  {label: '20', value: 20},
  {label: '25', value: 25},
  {label: '30', value: 30},
  {label: '35', value: 35},
  {label: '40', value: 40},
  {label: '45', value: 45},
  {label: '50', value: 50},
  {label: '55', value: 55},
  {label: '60', value: 60},
  {label: '70', value: 70},
  {label: '80', value: 80},
  {label: '90', value: 90},
  {label: '100', value: 100},
];

export const StandardPageSizes: LabelValue[] = [
  {label: '20', value: 20},
  {label: '50', value: 50},
  {label: '100', value: 100},
];

export const BroadcastTypes: LabelValue[] = [
  {label: 'ㅤ', value : ''},
  {label: 'new', value : 'new'},
  {label: 'repeat', value : 'repeat'}
]

export const EpgStatusses: LabelValue[] = [
  {label: 'QUEUED', value : 'QUEUED'},
  {label: 'STARTED', value : 'STARTED'},
  {label: 'FINISHED', value : 'FINISHED'},
  {label: 'FAILED', value : 'FAILED'},
  {label: 'TRIMMED', value : 'TRIMMED'}
]

export const ServiceTypes: Array<string> = new Array<string>('SVOD', 'TVOD', 'EST', 'PVOD', 'PAY');
export const countries: Array<string> = new Array<string>('United States', 'England', 'France');
